let cardList = [
    {name: "Durga", image: "./images/Durga.jpg"},
    {name: "Arjuna", image: "./images/Arjuna.jpg"},
    {name: "Bhima", image: "./images/Bhima.jpg"},
    {name: "Eklavya", image: "./images/Eklavya.jpg"},
    {name: "Ghatotkacha", image: "./images/Ghatotkacha.jpg"},
    {name: "Hanuman", image: "./images/Hanuman.jpg"},
    {name: "Karna", image: "./images/Karna.jpg"},
    {name: "Krishna", image: "./images/Krishna.jpg"},
    {name: "Rama", image: "./images/Rama.jpg"},
    {name: "Shiva", image: "./images/Shiva.jpg"},
    {name: "Vamana", image: "./images/Vamana.jpg"},
    {name: "Yudhishtira", image: "./images/Yudhishtira.jpg"},
]

export default cardList;